import React from "react";
import "./Mission.css";
import MissionImage from "../../assets/Rectangle3.png.webp";

const Mission: React.FC = () => {
  return (
    <section className="mission">
      <div className="mission-frame">
        {/* Text Section */}
        <div className="mission-text">
          <div className="mission-title">
            <h2>
              <span className="mission-highlight">Lighting </span>{" "}
              <span className="mission-bold">Transformation</span>
            </h2>
            <div className="mission-underline"></div>
          </div>
          <p className="mission-description">
            The company that had its humble beginnings in 1976 as Hawai
            Electronics which was confined to the import and distribution of
            consumer electronics has transformed to be a preferred supplier of
            electrical and lighting needs to the Sri Lankan market. Bixton
            imports, distributes and supplies a range of electrical and lighting
            products to the discerning Sri Lankan consumer who is looking for
            quality and range. We market a range of state-of-the-art elegant
            light fittings to meets the tastes of the modern house builders with
            a reliable aftersales back up.
          </p>
        </div>

        {/* Image Section */}
        <div className="mission-image">
          <img loading="lazy" decoding="async" src={MissionImage} alt="Mission" />
        </div>
      </div>
    </section>
  );
};

export default Mission;
